<template>
  <v-menu v-model="open" class="filter-menu" left offset-x :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-badge color="marca-1" :value="filtersQuantity" :content="filtersQuantity" overlap>
        <mf-button type="icon" icon="filter_list" color="cinza-0" v-on:click.native="on.click" />
      </v-badge>
    </template>
    <v-card width="425px">
      <v-card-text class="pb-0">
        <p class="mb-0 title-size">Filtros</p>
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12">
              <label class="detail-title grey-text"> Selecione uma campanha </label>
              <select-campaigns-modal
                ref="campaignsModal"
                v-model="campaigns"
                :mode="['sms', 'email', 'push', 'whatsapp']"
                :disabled="disable"
                include-maria-campaign
                get-products
              />
            </v-col>
            <v-col class="pb-0" cols="12">
              <label class="subtitle subtitle-size">Ou defina produtos e período para sua análise</label>
              <v-row>
                <v-col class="pb-0" cols="6">
                  <label class="detail-title">Período referência</label>
                  <mf-date-range-picker
                    :initial-date.sync="filters.reference_period_start"
                    :final-date.sync="filters.reference_period_end"
                    :disabled="disable"
                    :outlined="!!referencePeriodErrorMessage.length"
                    :solo="!referencePeriodErrorMessage.length"
                    :error="!!referencePeriodErrorMessage.length"
                    :error-messages="referencePeriodErrorMessage"
                  />
                </v-col>
                <v-col class="pb-0" cols="6">
                  <label class="detail-title">Período atual</label>
                  <mf-date-range-picker
                    :initial-date.sync="filters.period_start"
                    :final-date.sync="filters.period_end"
                    :disabled="disable"
                    :outlined="!!periodErrorMessage.length"
                    :solo="!periodErrorMessage.length"
                    :error="!!periodErrorMessage.length"
                    :error-messages="periodErrorMessage"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pb-0" cols="12">
              <label class="detail-title">Selecione os produtos</label>
              <modal-graphql-search-content
                :selected-items.sync="filters.products"
                item-type="produto"
                placeholder="Selecione ao menos 2 produtos"
                :outlined="!!productsErrorMessage.length"
                :solo="!productsErrorMessage.length"
                :error="!!productsErrorMessage.length"
                :error-messages="productsErrorMessage"
              />
            </v-col>
            <v-col class="pb-0" cols="12">
              <label class="detail-title">Selecione a quantidade de faixas</label>
              <mf-number-input
                v-model.lazy="filters.range_count"
                outlined
                :error="!!priceRangeErrorMessage.length"
                :error-messages="priceRangeErrorMessage"
                :min="2"
                :max="10"
                :value="filters.range_count"
                auto-format
              />
            </v-col>
          </v-row>
        </v-container>

        <mf-action-buttons
          class="pb-2"
          :primary-button="{
            text: 'Carregar análise',
            action: validateAndFilter,
            isVisible: true,
            isDisabled: false,
          }"
          :cancel-button="{
            text: 'Limpar',
            action: clearOptions,
            isVisible: true,
            isDisabled: false,
          }"
        />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import ModalGraphqlSearchContent from '@/components/ModalGraphqlSearchContent.vue'
import SelectCampaignsModal from '@/components/select-campaigns-modal/SelectCampaignsModal.vue'
import { DateTime } from 'luxon'
import { required, maxValue, minValue, minLength } from 'vuelidate/lib/validators'
import { isEmpty } from 'lodash'
export default {
  name: 'AnalyzeFilter',
  components: {
    ModalGraphqlSearchContent,
    SelectCampaignsModal,
  },
  props: {
    filters: {
      type: Object,
      required: false,
    },
    filtersQuantity: {
      type: Number,
      default: 0,
    },
    selectedCampaign: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    open: false,
    disable: false,
    periodErrorMessage: '',
    referencePeriodErrorMessage: '',
    productsErrorMessage: '',
    priceRangeErrorMessage: '',
    campaigns: [],
  }),
  computed: {
    currentDate() {
      const { period_start, period_end } = this.filters
      return [period_start, period_end]
    },
    localSelectedCampaign: {
      get() {
        return this.selectedCampaign
      },
      set(value) {
        this.$emit('update:selectedCampaign', value)
      },
    },
  },
  watch: {
    campaigns: {
      handler() {
        if (this.campaigns.length) {
          const { final_date, initial_date, start_date, end_date, products, _id } = this.campaigns[0]
          this.filters.period_start = initial_date ?? start_date
          this.filters.period_end = final_date ?? end_date
          if (products) this.filters.products = products
          this.filters.campaign = {
            _id,
            type: this.campaigns[0].campaign_type || 'OFFER_SCHEDULE',
          }
          this.disable = true
          this.localSelectedCampaign = this.campaigns[0]
          this.setReferenceDate()
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (!isEmpty(this.selectedCampaign)) {
      this.campaigns[0] = this.selectedCampaign
    }
  },
  methods: {
    validateAndFilter() {
      this.$v.$reset()
      this.$v.$touch()

      if (!this.$v.filters.period_start.required || !this.$v.filters.period_end.required) {
        this.periodErrorMessage = 'Campo obrigatório.'
      } else if (!this.$v.filters.period_start.startDateBiggerThanEnd || !this.$v.filters.period_end.endDateLowerThanStart) {
        this.periodErrorMessage = 'Preencha o campo corretamente.'
      } else if (!this.$v.filters.period_start.periodStartDateBiggerThanReferenceStart) {
        this.periodErrorMessage = 'Período inválido'
      } else {
        this.periodErrorMessage = ''
      }

      if (!this.$v.filters.reference_period_end.required || !this.$v.filters.reference_period_start.required) {
        this.referencePeriodErrorMessage = 'Campo obrigatório.'
      } else if (
        !this.$v.filters.reference_period_end.referenceEndDateLowerThanStart ||
        !this.$v.filters.reference_period_start.referenceStartDateBiggerThanEnd
      ) {
        this.referencePeriodErrorMessage = 'Preencha o campo corretamente.'
      } else if (!this.$v.filters.reference_period_start.referenceStartDateBiggerThanPeriodStart) {
        this.referencePeriodErrorMessage = 'Período inválido'
      } else {
        this.referencePeriodErrorMessage = ''
      }

      if (!this.$v.filters.products.required) {
        this.productsErrorMessage = 'Campo obrigatório.'
      } else if (!this.$v.filters.products.minLength) {
        this.productsErrorMessage = `Você precisa selecionar no mínimo ${this.filters.range_count} produto(s)`
      } else {
        this.productsErrorMessage = ''
      }

      if (!this.$v.filters.range_count.required || !this.$v.filters.range_count.minValue) {
        this.priceRangeErrorMessage = 'Campo obrigatório.'
      } else if (!this.$v.filters.range_count.maxValue) {
        this.priceRangeErrorMessage = 'Valor máximo de 10'
      } else if (!this.$v.filters.range_count.productValidation) {
        this.priceRangeErrorMessage = 'Você não pode selecionar mais faixas do que produtos'
      } else {
        this.priceRangeErrorMessage = ''
      }

      if (!this.$v.$error) {
        this.open = false
        this.$emit('new-search')
      }
    },
    clearOptions() {
      this.campaigns.pop()
      this.disable = false
      this.$refs.campaignsModal.clearCampaigns()
      this.$emit('clear-filters')
    },
    setReferenceDate() {
      this.filters.reference_period_start = DateTime.fromISO(this.filters.period_start).plus({ days: -31 }).toFormat('yyyy-MM-dd')
      this.filters.reference_period_end = DateTime.fromISO(this.filters.period_start).plus({ days: -1 }).toFormat('yyyy-MM-dd')
    },
  },
  validations() {
    return {
      filters: {
        reference_period_start: {
          required,
          referenceStartDateBiggerThanEnd: (value) => {
            if (DateTime.fromISO(value) > DateTime.fromISO(this.filters.reference_period_end)) return false
            return true
          },
          referenceStartDateBiggerThanPeriodStart: (value) => {
            if (DateTime.fromISO(value) > DateTime.fromISO(this.filters.period_start)) return false
            return true
          },
        },
        reference_period_end: {
          required,
          referenceEndDateLowerThanStart: (value) => {
            if (DateTime.fromISO(value) < DateTime.fromISO(this.filters.reference_period_start)) return false
            return true
          },
        },
        period_start: {
          required,
          startDateBiggerThanEnd: (value) => {
            if (DateTime.fromISO(value) > DateTime.fromISO(this.filters.period_end)) return false
            return true
          },
          periodStartDateBiggerThanReferenceStart: (value) => {
            if (DateTime.fromISO(value) < DateTime.fromISO(this.filters.reference_period_start)) return false
            return true
          },
        },
        period_end: {
          required,
          endDateLowerThanStart: (value) => {
            if (DateTime.fromISO(value) < DateTime.fromISO(this.filters.period_start)) return false
            return true
          },
        },
        products: {
          required,
          minLength: minLength(this.filters.range_count),
        },
        range_count: {
          required,
          maxValue: maxValue(10),
          minValue: minValue(1),
          productValidation: (value) => {
            return !(value > this.filters.products.length)
          },
        },
      },
    }
  },
}
</script>

<style lang="scss">
.title-size {
  font-size: 18px !important;
  font-weight: 500;
  letter-spacing: 0.0125em !important;
  color: $cinza-d10;
}

.subtitle-size {
  font-size: 16px !important;
  color: $cinza-d10 !important;
}

input {
  font-size: 14px !important;
  color: $cinza-0 !important;
}

input:disabled {
  color: rgba(0, 0, 0, 0.38) !important;
}

.v-input--is-disabled .v-input__control .v-input__slot {
  background-color: $cinza-l90 !important;
}

.detail-title {
  color: $cinza-0;
  font-size: 16px;
}

.grey-text {
  color: $cinza-d10;
}

.button-font-size {
  font-size: 18px !important;
}
</style>
